import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { validationRules } from './validation';

@Component({
  selector: 'app-custom-datatable',
  templateUrl: './custom-datatable.component.html',
  styleUrls: ['./custom-datatable.component.scss']
})
export class CustomDatatableComponent implements OnInit {
  @Input() schemaName: string = '';
  @Input() verticleTableHeaderTitle: string = '';


  @Input() columns: any[] = [];
  @Input() data: any[] = [];
  @Input() totalItems: number;
  @Input() onCellRender: Function;

  @Output() dataChange = new EventEmitter<any>();
  @Output() onCellClick = new EventEmitter();


  @Input() columnsPerRow: number = 1;
  groupedColumns: any[];

  errors: any = {};
  Math = Math;
  array = Array;
  ngOnInit() {
    this.groupColumns();
    this.storeOriginalData();
   }

  renderCell(data) {
    return this.onCellRender(data);
  }

  cellClick(column, item, event) {
    item.column = column;
    item.coreEvent = event;
    if (column.clickable) {
      this.onCellClick.emit(item);
    }
  }

  /** Grid view table */

  groupColumns(): void {
    if (this.columns && this.columns.length) {
      this.groupedColumns = [];
      for (let i = 0; i < this.columns.length; i += this.columnsPerRow) {
        this.groupedColumns.push(this.columns.slice(i, i + this.columnsPerRow));
      }
    }

  }


  /**
   * Validates a single field based on its type.
   * @param field - Field name in newRow
   * @param type - Type of field (text, number, date, currency, etc.)
   */
  validateField(field: string, type: string, index?: any, data?: any) {
    const column = this.columns.find(col => col.field === field);
    const value = index !== undefined ? data[field] : '';

    let errorMessage = null;

    if (column && column.validations) {
      errorMessage = this.applyValidations(value, column.name, column.validations);
    }
    if(!errorMessage && column.type==='number' && value<0){
      errorMessage = `${column.name} must be a positive number.`
    }

    if (index !== undefined) {
      this.errors[index] = { ...(this.errors[index] || {}), [field]: errorMessage };
    } else {
      this.errors[field] = errorMessage;
    }

  }


  applyValidations(value: any, fieldTitle: string, validations: string[]) {
    for (const rule of validations) {
      const message = validationRules[rule](value, fieldTitle);
      if (message !== true) {
        return message;
      }
    }
    return null;

  };




  // Format Value based on column type
  formatValue(value: any, col: any): string {
    if (col.unit === "currency") {
      return value ? `$${Number(value).toFixed(2)}` : "NA";
    }
    if (col.type === "date") {
      return value ? new Date(value).toLocaleDateString("en-US") : "NA";
    }
    return value || "NA";
  }


  @Output() onDataSave = new EventEmitter<any>();
  @Input() tableTitle: any;
  @Input() isEditMode: boolean = false;
  @Output() onToggleEdit = new EventEmitter<boolean>();

  originalData: any[] = [];

  storeOriginalData() {
    if (this.data) {
      this.originalData = JSON.parse(JSON.stringify(this.data));
    }

  }

  toggleEditMode() {
    this.onToggleEdit.emit(!this.isEditMode);
  }
  cancelEdit() {
    this.data = JSON.parse(JSON.stringify(this.originalData)); // Restore original data
    this.onToggleEdit.emit(false); // Exit edit mode
  }




  editingEnabled: boolean = false;

  toggleEditing(): void {
    if (this.editingEnabled) {
      this.saveChanges();
    } else {
      this.startEditing();
    }
  }

  startEditing(): void {
    this.editingEnabled = true;
    this.originalData = JSON.parse(JSON.stringify(this.data)); // Deep copy
  }

  saveChanges(): void {
    let isValid = true;
    this.errors = {}; 
    let filteredColumns = this.columns.filter(column => column.visible);
    filteredColumns.forEach(col => {
      this.validateField(col.field, col.type, 0, this.data[0]);
      if (this.errors[0][col.field]) {
        isValid = false; 
      }
    });
  
    if (!isValid) {
      return; 
    }
  
    this.editingEnabled = false;
    this.onDataSave.emit({ data: this.data, type: 'edit', schemaName: this.schemaName });
  }
  

  discardChanges(): void {
    this.data = JSON.parse(JSON.stringify(this.originalData));
    this.editingEnabled = false;
  }



  formatCurrency(value: number, locale: string = 'en-US', currency: string = 'USD'): string {
    return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(value && !isNaN(value) ? value : 0);
  }

  formatNumber(value: number, locale: string = 'en-US'): string {
    return new Intl.NumberFormat(locale).format(value);
  }
  
}
